const BasicLayout = ({ children }) => children;

export default BasicLayout;
